import { c as _c } from "react/compiler-runtime";
export const DebugMessage: React.FC<{
  content: string;
}> = t0 => {
  const $ = _c(2);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = <section className="bg-white text-black px-4 py-2 rounded-lg text-xs"><pre className="whitespace-pre-wrap wrap-break-word">{content}</pre></section>;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};